import { Div, Ref } from "@tblabs/truffle";


export class Svg extends Div
{
    constructor(svgAsText: string | Ref<string>)
    {
        super();
        this.DisplayInlineBlock()

        if (svgAsText instanceof Ref)
        {
            svgAsText.OnChange(v => this.Html(v), true);
        }
        else
        {
            this.Html(svgAsText);
        }
    }
}
